import { Link } from 'react-router-dom';
import { resolveMemberMediaUrl } from '@formosa/shared/utils/mediaUrl';
import SafeImage from '../../../components/SafeImage';
import { formatChatTime } from '../travelChatModel';
import {
  CARD_SCHEMA_V1,
  MEMORY_RENDERER_KEY,
  cardFallbackText,
  cardSchemaVersion,
  isSupportedCardSchema,
  normalizeMemoryBusinessCard,
} from './travelCardModel';

const UNSUPPORTED = '此卡片目前無法顯示';

export default function MemoryCardMessage({ message }) {
  const card = normalizeMemoryBusinessCard(message?.businessCard);
  if (!card || card.rendererKey !== MEMORY_RENDERER_KEY) {
    return <p>{cardFallbackText(message, UNSUPPORTED)}</p>;
  }
  if (!isSupportedCardSchema(card)) {
    return (
      <p>
        {cardFallbackText(message, UNSUPPORTED)}
        <span className="visually-hidden"> schema {String(cardSchemaVersion(card))}</span>
      </p>
    );
  }
  if (!card.memoryEntryId && !card.title && !card.contentPreview) {
    return <p>{cardFallbackText(message, UNSUPPORTED)}</p>;
  }

  const coverUrl = card.coverObjectKey ? resolveMemberMediaUrl(card.coverObjectKey) : '';
  const occurred = formatChatTime(card.occurredAt) || String(card.occurredAt || '').replace('T', ' ');

  return (
    <article className="travel-msg-card" aria-label="旅程日記">
      <p className="travel-msg-card__kicker">旅程日記</p>
      <h2 className="travel-msg-card__title">{card.title || cardFallbackText(message, '日記')}</h2>
      {card.contentPreview ? <p>{card.contentPreview}</p> : null}
      {occurred ? <p><time dateTime={card.occurredAt}>{occurred}</time></p> : null}
      {card.dayContext ? <p>日期：{card.dayContext}</p> : null}
      {card.activityTitle ? <p>活動：{card.activityTitle}</p> : null}
      {coverUrl ? (
        <SafeImage
          className="travel-msg-card__cover"
          src={coverUrl}
          alt={card.title ? `${card.title} 封面` : '日記封面'}
        />
      ) : null}
      {card.webRoute ? (
        <Link className="travel-msg-card__cta" to={card.webRoute}>
          查看日記
        </Link>
      ) : null}
      <span className="visually-hidden">schema {CARD_SCHEMA_V1}</span>
    </article>
  );
}
